import { render, staticRenderFns } from "./hiveSidebar.vue?vue&type=template&id=4f5ba48d&scoped=true"
import script from "./hiveSidebar.vue?vue&type=script&lang=js"
export * from "./hiveSidebar.vue?vue&type=script&lang=js"
import style0 from "@dss/assets/styles/sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./hiveSidebar.vue?vue&type=style&index=1&id=4f5ba48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ba48d",
  null
  
)

export default component.exports